import React from "react";
import LgvRadioGroup from "../../../components/LgvRadioGroup";
import { QuestionItem } from "../../../types/form";
import {
  getYesNoRadioOptions,
  type LgvRadioOption,
} from "../../../utils/radioOptions";

interface YesNoFieldRendererProps {
  question: QuestionItem;
  inputName: string;
  currentValue: unknown;
  options?: LgvRadioOption[];
  setFormData: (update: (prev: Record<string, any>) => Record<string, any>) => void;
  readOnly?: boolean;
}

const YesNoFieldRenderer: React.FC<YesNoFieldRendererProps> = ({
  question,
  inputName,
  currentValue,
  options,
  setFormData,
  readOnly = false,
}) => {
  return (
    <LgvRadioGroup
      name={inputName}
      value={currentValue}
      options={options ?? getYesNoRadioOptions()}
      disabled={readOnly}
      required={question.isRequired}
      className="grid grid-cols-2 gap-3 space-y-0 [&>label]:flex [&>label]:min-h-[48px] [&>label]:items-center [&>label]:justify-center [&>label]:text-center [&>label+label]:mt-0 [&>label>div]:justify-center"
      onChange={(value) =>
        setFormData((prev) => ({
          ...prev,
          [inputName]: value,
        }))
      }
    />
  );
};

export default YesNoFieldRenderer;
